import { createSlice } from '@reduxjs/toolkit';

import { getAllCategoryApi } from 'redux/stores/storeApi';
import { getAllCategoriesApi, getAllRootCategoriesApi, getCategoryByCategoryIdApi } from './categoryApi';

// ----------------------------------------------------------------------

const initialState = {
  categoriesList: [],
  rootCategoryList: [],
  selectedCategory: {},
  isCategoriesLoading: false,
  subCatParentList: []
};

const slice = createSlice({
  name: 'categories',
  initialState,
  reducers: {},
  extraReducers: {
    [getAllCategoriesApi.pending]: (state) => {
      state.isCategoriesLoading = true;
      state.categoriesList = [];
    },
    [getAllCategoriesApi.fulfilled]: (state, action) => {
      state.categoriesList = action.payload;
      state.isCategoriesLoading = false;
    },
    [getAllCategoriesApi.rejected]: (state) => {
      state.isCategoriesLoading = false;
    },
    [getAllRootCategoriesApi.fulfilled]: (state, action) => {
      state.rootCategoryList = action.payload;
    },
    [getCategoryByCategoryIdApi.fulfilled]: (state, action) => {
      state.selectedCategory = action.payload;
    },
    [getAllCategoryApi.fulfilled]: (state, action) => {
      state.subCatParentList = action.payload;
    }
  }
});
export const { actions } = slice;
export const storeActions = slice.actions;

export default slice.reducer;
